import { ParallelAiType } from "@/enum/parallel-ai-type.enum";

import { CreateParallelAi } from "../schema/parallelAi";

/**
 * Ensure the submitted payload only carries data relevant to the selected mode:
 * monitor-only fields (frequency / processor / location) are cleared for SEARCH sources.
 */
export const normalizePayloadForMode = (
	values: CreateParallelAi,
	mode: ParallelAiType
): CreateParallelAi => {
	const normalized: CreateParallelAi = { ...values, type: mode };

	if (mode !== ParallelAiType.MONITOR) {
		normalized.frequency = null;
		normalized.processor = null;
		normalized.location = null;
	}

	return normalized;
};
